var map = {
	"./pr-1.png": "43f5",
	"./pr-2.png": "407a",
	"./pr-3.png": "6e26",
	"./pr-4.png": "a63b",
	"./pr-5.png": "9e9a",
	"./pr-6.png": "9938",
	"./pr-7.png": "956f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2a2";